<template>
  <div :class="isMobile?'mobile':'pc'">
    <div class="student-entry">
      <lw-container>
        <lw-student-banner slot="header"></lw-student-banner>
        <div slot="main" class="student-entry-body">
          <el-lw-bread-crumb @click="toRemoteRouter"></el-lw-bread-crumb>

          <div class="student-entry-body-body">
            <div class="student-entry-body-body-title">
              <span>加入马良笔双师课堂</span>
            </div>
            <div class="student-entry-body-body-content">
              <el-form ref="from" :label-position="labelPosition" :model="classroom" :rules="rules" @submit.native.prevent>
                <el-form-item label="课堂ID码：" prop="classroomId">
                  <el-input v-model="classroom.classroomId" placeholder="6位数字或字母，必填。" maxlength="6"></el-input>
                  <p class="student-entry-body-body-content-tips"
                     v-if="formValidateSuccess && !submitLoading">提示：该课堂ID码由发起课堂的老师提供。</p>
                </el-form-item>
              </el-form>
              <div class="student-entry-body-body-content-button">
                <el-button type="primary" v-prevent-db-click @click="submitForm" :disabled="submitButtonDisable">加入
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <lw-footer slot="footer"></lw-footer>
      </lw-container>


    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {UserType} from "@/ts/Enum"
import RTCClient from "@/rtc/RTCClient";


export default {
  name: 'StudentEntry',
  data() {
    return {
      // 当前登录的学生信息
      studentInfo: null,
      mqttClientId: '',
      // 园区ID
      gardenId: '',
      // 当前认证TOKEN
      token: '',
      // 当前用户在rtc中的的身份
      userType: UserType.student,
      // 加入课堂表单的绑定对象
      classroom: {
        classroomId: ''
      },
      // 加入课堂表单的校验规则
      rules: {
        classroomId: [
          { required: true, message: '请输入课堂ID码', trigger: 'blur' },
          { pattern: /^[0-9A-Za-z]{6}$/, message: '课堂ID码必须是六位数字或者字母', trigger: 'blur' }
        ]
      },
      submitButtonDisable: true,
      joinErrorMessage: '',
      formValidateSuccess: true,
      submitLoading: false,
      // 加入课堂弹框内表单的对其方式
      labelPosition: 'right',
      // 当前客户端是否支持rtc，默认为false
      currentClientSupportRtc: false
    }
  },
  created() {
    this.checkRtcSupport()
  },
  /**
   *页面初始化
   */
  mounted() {
    this.gardenId = window.localStorage.getItem('gardenId')
    this.token = window.localStorage.getItem('LWToken')
    // 获取学生所属的班级列表
    let userInfoJson = window.localStorage.getItem('userInfo')
    if (userInfoJson) {
      this.studentInfo = JSON.parse(userInfoJson)
    }

  },
  watch: {
    // 创建马良笔双师课堂表单
    classroom: {
      handler() {
        this.joinErrorMessage = ''
        this.validate()
      },
      deep: true
    }
  },
  methods: {
    /**
     * 校验浏览器是否支持rtc
     */
    checkRtcSupport() {
      RTCClient.instance.isSupport().then(res => {
        const {isSupported} = res
        // 如果不支持，给出提示弹框
        this.currentClientSupportRtc = isSupported
        RTCClient.instance.dispose()
      }, err => {
        this.currentClientSupportRtc = false
        RTCClient.instance.dispose()
      }).catch(err => {
        this.currentClientSupportRtc = false
        RTCClient.instance.dispose()
      })
    },

    /**
     * 展示当前浏览器不支持rtc时的确认弹框
     */
    showRtcNotSupportConfirm() {
      let confirmTitle =
        '<div style="font-size: 16px;text-indent:2em;line-height: 30px">您当前使用的浏览器类型或版本不支持发起音视频双向通信。请更换至以下浏览器类型或版本后再试：\n' +
        'Chrome浏览器72或以上版本，Edge浏览器80或以上版本</div>';

      this.$elementConfirm(confirmTitle, "提示", {
        confirmButtonText: "确定",
        customClass: this.isMobile ? 'mobile-confirm-box' : '',
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        closeOnClickModal: false,
        transition: "",
        // type: 'warning'
      }).then(() => {
      })
    },

    /**
     * 表单校验函数
     */
    validate() {
      // 如果输入框无内容，直接禁用
      if (!this.classroom.classroomId) {
        this.submitButtonDisable = true
        return
      }
      this.$refs['from'].validate((valid) => {
        this.formValidateSuccess = valid
        this.submitButtonDisable = !valid
      })
    },

    /**
     * 提交表单
     */
    submitForm() {
      const _that = this
      function submit() {
        if (!_that.currentClientSupportRtc) {
          _that.showRtcNotSupportConfirm()
          return
        }
        _that.submitLoading = true
        _that.joinErrorMessage = ''
        _that.$refs['from'].validate((valid) => {
          if (valid) {
            _that.joinClassroom()
          } else {
            _that.submitLoading = false
          }
        })
      }
      if (this.currentClientSupportRtc === null || this.currentClientSupportRtc === undefined) {
        setTimeout(() => {
          submit();
        }, 1000)
      } else {
        submit();
      }

    },

    joinClassroom() {
      RTCClient.instance.getAuthInfo(
        this.token,
        this.classroom.classroomId,
        'PA',
        this.userType,
        this.gardenId
      ).then(res => {
        this.submitLoading = false
        this.classIdCodeJoinClassroom(this.classroom.classroomId, res)
      }).catch(err => {
        switch (err.Code) {
          case 700:
          case 702:
          case 703:
            //  701:云端未知异常
            //  702:云端获取园区对应的rtc AppID和appkey 报错
            //  703:云端获取当前频道ID的可用性时报错
            this.joinErrorMessage = err.Message.UserMsg
            break
          case 701:
            this.$message.error('您当前的音视频通信认证令牌已超过最大允许时长。系统将自动结束当前课堂。')
            this.local$.clearLocal()
            this.cookie$.removeCookie("LWToken")
            //  用户的优课场域认证token时效，回到登录页面
            window.open(this.filePre$.loginUrl + "/logout", "_self")
            break
          case 704:
            //  当前请求的频道ID不可用
            this.joinErrorMessage = '根据该课堂ID码未查询到当前正在发起的马良笔双师课堂！'
            break
          default:
            this.joinErrorMessage = err.Message.UserMsg
            break
        }
        if (this.joinErrorMessage) {
          let confirmTitle =
            '<div style="font-size: 16px;text-indent:2em;line-height: 30px">'+this.joinErrorMessage+'</div>';

          this.$elementConfirm(confirmTitle, "提示", {
            confirmButtonText: "确定",
            customClass: this.isMobile ? 'mobile-confirm-box' : '',
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
            closeOnClickModal: false,
            transition: "",
            // type: 'warning'
          }).then(() => {
          })
        }
        this.submitLoading = false
      })
    },

    /**
     * 通过课堂ID码加入课堂
     */
    classIdCodeJoinClassroom(classIdCode, authInfo) {
      this.$router.push({
        name: this.isMobile?'StudentClassroomMobile':'StudentClassroom',
        params: {
          class_id_code: classIdCode,
          rtc_auth_info: authInfo,
          user_id: this.studentInfo.id,
          user_type: this.userType,
          display_name: this.studentInfo.name
        }
      })
    },

    toRemoteRouter() {
      let gardenId = window.localStorage.getItem("gardenId")
      let qToken = window.localStorage.getItem("LWToken")
      // window.location.href =
      //     this.filePre$.studentAirCLassRoomUrl +
      //     `moduleEntry?gardenId=${gardenId}&token=${qToken}`

      window.location.href =
        this.filePre$.studentAirCLassRoomUrl +
        `?gardenId=${gardenId}&token=${qToken}`
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/index.scss";

.pc {
  .student-entry {
    width: 100%;

    &-body {
      width: calc(100% - #{computer(40px)});
      padding: computer(20px) computer(20px) 0;

      &-header {
        width: 100%;
        height: computer(50px);
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        &-title {
          margin-top: computer(27px);
          margin-left: computer(15px);

          span {
            height: computer(24px);
            line-height: computer(24px);
            font-size: computer(16px);
            font-weight: 700;
          }
        }

        &-operation {
          margin-right: computer(10px);
        }
      }

      &-body {
        width: calc(100% - #{computer(40px)});
        padding: computer(20px) computer(20px) 0;

        &-title {
          margin-top: computer(20px);
          text-align: center;

          span {
            height: computer(30px);
            line-height: computer(30px);
            font-size: computer(24px);
            font-weight: 700;
          }
        }

        &-content {
          width: calc(100% - #{computer(30px)});
          margin: computer(60px) computer(15px) 0;

          ::v-deep .el-form {
            width: computer(550px);
            margin: 0 auto;

            .el-form-item {
              margin: 0 computer(40px) computer(40px) computer(-40px);

              .el-form-item__label {
                width: computer(120px);
                padding: 0;
              }

              .el-form-item__content {
                width: calc(100% - #{computer(140px)});
                margin-left: computer(120px);
              }
            }
          }

          &-tips {
            height: computer(18px);
            line-height: computer(18px);
            font-size: computer(12px);
            color: $color_font-light;
          }

          &-error {
            height: computer(18px);
            line-height: computer(18px);
            color: $color_error;
            font-size: computer(14px);
            text-align: center;
          }

          &-button {
            margin-top: computer(20px);
            text-align: center;

            ::v-deep .el-button {
              width: computer(300px);

            }
          }

        }
      }
    }
  }
}

.mobile {
  .student-entry {
    width: 100%;

    &-body {
      min-height: calc(100vh - #{computer(150px)});
      width: calc(100% - #{computer(20px)});
      padding: computer(10px) computer(10px) computer(20px);

      &-header {
        width: 100%;
        height: computer(50px);
        display: flex;
        justify-content: space-between;
        align-items: center;

        &-title {
          margin-right: 5px;
          text-align: left;
          span {
            height: computer(18px);
            line-height: computer(18px);
            font-size: computer(14px);
            font-weight: 700;
          }
        }

        &-operation {
          margin-right: 0px;
        }
      }

      &-body {
        width: calc(100% - #{computer(10px)});
        padding: computer(20px) computer(5px) 0;

        &-title {
          margin-top: computer(20px);
          text-align: center;

          span {
            height: computer(30px);
            line-height: computer(30px);
            font-size: computer(24px);
            font-weight: 700;
          }
        }

        &-content {
          width: 100%;
          margin: computer(60px) computer(15px) 0;

          ::v-deep .el-form {
            width: 100%;
            margin: 0 auto;

            .el-form-item {
              margin: 0 computer(40px) computer(40px) computer(-40px);

              .el-form-item__label {
                width: computer(120px);
                padding: 0;
              }

              .el-form-item__content {
                width: calc(100% - #{computer(140px)});
                margin-left: computer(120px);
              }
            }
          }

          &-tips {
            height: computer(18px);
            line-height: computer(18px);
            font-size: computer(12px);
            color: $color_font-light;
          }

          &-error {
            height: computer(18px);
            line-height: computer(18px);
            color: $color_error;
            font-size: computer(14px);
            text-align: center;
          }

          &-button {
            margin-top: computer(20px);
            text-align: center;

            ::v-deep .el-button {
              width: 50%;

            }
          }

        }
      }
    }
  }

  ::v-deep {

    .el-message-box {
      width: 60%;
    }
  }
}


</style>
